import React from 'react';
import classnames from 'classnames';

import { Link } from 'gatsby';
import { withMenuContext } from '../Menu/MenuContext/MenuContext';
import Wrapper from '../Wrapper';

import LogoMRG from '../../assets/images/mrg_inline.svg';
import LogoMRGTouch from '../../assets/images/mrg_inline_touch.svg';
import MenuIcon from '@paradigm/icons/src/mailru/navigation/menu.svg';

import * as T from './Header.types';
import * as S from './Header.module.css';

const Header: React.FunctionComponent<T.IHeaderContext> = ({
  className,
  image,
  imageRetina,
  imageHeight,
  bgMarginTop = 90,
  children,
  toggle,
  MainLogo,
  MainLogoTouch,
  additionalLogo,
  bgClassName,
  bgColor,
  withoutLogo,
  isMenu = true,
  burgerColor = 'white',
}) => {
  const backgroundStyles: React.CSSProperties = {
    backgroundColor: bgColor,
  };

  const imageStyles: React.CSSProperties = {
    maxHeight: imageHeight,
    width: !imageHeight && '100%',
    marginTop: bgMarginTop,
  };

  const srcSet: string = imageRetina && `${image} 1x, ${imageRetina} 2x`;

  const headerClass = classnames(S.header, className);
  const headerNavClass = classnames(S.headerNav, bgClassName);

  return (
    <header className={headerClass}>
      <Wrapper>
        {image && (
          <img
            alt="Картинка в заголовке"
            className={S.headerBg}
            style={imageStyles}
            src={image}
            srcSet={srcSet}
          />
        )}
      </Wrapper>
      <div className={headerNavClass} style={backgroundStyles}>
        <div className={S.logo}>
          {isMenu && (
            <MenuIcon
              fill={burgerColor}
              height={32}
              width={32}
              className={S.menuIcon}
              onClick={toggle}
            />
          )}
          {!withoutLogo && (
            <Link to={'/'} className={S.headerLogoLink}>
              {MainLogo ? (
                <MainLogo className={S.headerLogoMrg} height={32} />
              ) : (
                <LogoMRG className={S.headerLogoMrg} height={32} />
              )}
              {MainLogoTouch ? (
                <MainLogoTouch className={S.headerLogoMrgTouch} height={32} />
              ) : MainLogo ? (
                <MainLogo className={S.headerLogoMrgTouch} height={32} />
              ) : (
                <LogoMRGTouch className={S.headerLogoMrgTouch} height={32} />
              )}
            </Link>
          )}
          {additionalLogo && (
            <div className={S.headerLogoHome}>{additionalLogo}</div>
          )}
        </div>
      </div>
      {children}
    </header>
  );
};

// @ts-ignore
export const HeaderContext = withMenuContext<T.IHeaderProps>(Header);
